import ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import { getListViewStore } from '../store/Store';
import { MeetingMessageType } from 'mini-calendar-event-services/lib/schema/MeetingMessageType';
import { shouldLatestMeetingItemShowRsvp } from 'mini-meeting-invite/lib/utils/shouldLatestMeetingItemShowRsvp';

// Returns the meeting client item if all the requirements are met
export const getMeetingClientItem = (itemId: string): ClientItem | null => {
    const clientItem = getListViewStore().meetingMessageItems.get(itemId);

    // The item is not on store yet (GetItem not completed)
    if (!clientItem) {
        return null;
    }

    const meetingItem = clientItem as MeetingMessageType;

    // Check these properties since these will indicate that we got the item with all properties that we need
    if (!shouldLatestMeetingItemShowRsvp(meetingItem)) {
        return null;
    }

    return clientItem;
};
